import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "../src/context/AuthContext";
import { SchoolProvider } from "../src/context/SchoolContext";
import { ExamProvider } from "./context/ExamContext";
import { ExamDetailsProvider } from "./context/ExamDetailsContext";
import Shell from "../src/components/Layout/Shell";
import Login from "./Pages/Auth/Pages";
import Dashboard from "./Pages/Dashboard/Pages";
import SchoolProfile from "./Pages/Profile/SchoolProfile";
import ProtectedRoute from "../src/components/Layout/ProtectedRoute";
import CreateQuestion from "../src/Pages/ExamSetup/GenerateExam.js";
import ViewPdf from "./Pages/QuestionView/QuestionView.js";
import NotFound404 from "./Pages/404/Error";

function App() {
  return (
    <Router>
      <AuthProvider>
        <SchoolProvider>
          <ExamProvider>
            <ExamDetailsProvider>
              <Routes>
                {/* Public route */}
                <Route path="/" element={<Login />} />

                {/* Protected routes */}
                <Route element={<ProtectedRoute />}>
                  <Route element={<Shell />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/school-profile" element={<SchoolProfile />} />
                    <Route
                      path="/create-question"
                      element={<CreateQuestion />}
                    />
                    <Route path="/pdf-view" element={<ViewPdf />} />
                  </Route>
                </Route>

                {/* Catch-all 404 */}
                <Route path="*" element={<NotFound404 />} />
              </Routes>
            </ExamDetailsProvider>
          </ExamProvider>
        </SchoolProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
